import { api } from '../api'

export const checklistsApi = api
  .enhanceEndpoints({
    addTagTypes: ['checklists'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      addChecklist: builder.mutation({
        query: ({ taskId, data }) => ({
          url: `/task-check-item/task/${taskId}`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['checklists'],
      }),
      deleteChecklist: builder.mutation({
        query: ({ itemId }) => ({
          url: `/task-check-item/delete-list/${itemId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['checklists'],
      }),
      updatePointChecklist: builder.mutation({
        query: ({ itemId, data }) => {
          return {
            url: `/task-check-item/update/${itemId}`,
            method: 'PATCH',
            body: data,
          }
        },
        invalidatesTags: ['checklists'],
      }),
    }),
  })

export const {
  useAddChecklistMutation,
  useDeleteChecklistMutation,
  useUpdatePointChecklistMutation,
} = checklistsApi
